const filterDataBySearch = (
  dataList: any[],
  search: string,
  keysToSearch: string[],
  setDataFn: React.Dispatch<any>
) => {
  const filteredData = dataList.filter((item: any) => {
    const searchMatch =
      !search ||
      keysToSearch.some((key: any) => {
        if (key.includes(".")) {
          const nestedKeys = key.split(".");
          let nestedItem = item;
          for (const nestedKey of nestedKeys) {
            nestedItem = nestedItem[nestedKey];
            if (!nestedItem) {
              break;
            }
          }
          if (nestedItem !== undefined && nestedItem !== null) {
            const nestedItemStr = nestedItem.toString().toLowerCase();
            return nestedItemStr.includes(search.toLowerCase());
          }
        } else {
          const itemValue = item[key];
          if (itemValue !== undefined && itemValue !== null) {
            const itemValueStr = itemValue.toString().toLowerCase();
            return itemValueStr.includes(search.toLowerCase());
          }
        }
        return false;
      });

    return searchMatch;
  });

  setDataFn(filteredData);
};


export default filterDataBySearch;
